import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';

import messages from './messages';
import styles from './styles';

const getTitleLabel = (ticketableFareGroup) => {
    if (ticketableFareGroup.startDate) {
        return 'lblLegHeaderSeason';
    }
    if (ticketableFareGroup.containsTravelCard) {
        return 'lblLegHeaderTravelCard';
    }
    return 'lblLegHeaderRail';
};

function TicketableFareGroupTitle({
    classes,
    ticketableFareGroup,
    showSplitTitle,
    departStation,
    arriveStation,
}) {
    return (
        <div className={classes.boldText}>
            <FormattedMessage
                {...messages[getTitleLabel(ticketableFareGroup)]}
                values={{
                    description: showSplitTitle ? `${departStation} to ${arriveStation}` : ticketableFareGroup.description,
                    marketingCarrierReference: ticketableFareGroup.marketingCarrierReference || ticketableFareGroup.referenceCode,
                    hasMarketingCarrierReference: !!(ticketableFareGroup.marketingCarrierReference || ticketableFareGroup.referenceCode),
                }}
            />
            {!!ticketableFareGroup.passengers?.length && (
                <div className={classes.subBoldText}>
                    <FormattedMessage
                        {...messages.lblPassengers}
                        values={{
                            passengers: ticketableFareGroup.passengers
                                .sort((a, b) => (a.passengerId > b.passengerId ? 1 : -1))
                                .map((passenger) => `${passenger.firstName} ${passenger.lastName}`)
                                .join(', '),
                        }}
                    />
                </div>
            )}
        </div>
    );
}

TicketableFareGroupTitle.propTypes = {
    classes: PropTypes.object.isRequired,
    ticketableFareGroup: PropTypes.object,
    showSplitTitle: PropTypes.bool,
    departStation: PropTypes.string,
    arriveStation: PropTypes.string,
};
export { TicketableFareGroupTitle as TicketableFareGroupTitleAlias };

export default withStyles(styles)(TicketableFareGroupTitle);
